import React, { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Tool from '../../components/click-open-banner'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { unitPrice } from '../../../../../../../utils/product'

export default props => {
    useStyles(classes)
    const intl = useIntl()
    const { canUseCouponCount, coupon, onClick, availableCouponCount, mostPreferredCoupon } = props
    const couponName = coupon ? <span className={classes.CouponName}>
        {coupon.name || coupon.couponName || coupon.couponName2}
    </span> : <span className={classes.CouponDescription}>
        {
            availableCouponCount > 0 ? <span className={classes.Tip}>
                <span>{availableCouponCount} {intl.formatMessage({id: 'available',defaultMessage:'Available'})}</span>
                {
                    mostPreferredCoupon && <span>
                        ,<FormattedMessage id="up_to_saving" defaultMessage="up to {coupon} savings" values={{coupon: unitPrice(mostPreferredCoupon.saved)}}/>
                    </span>
                }
            </span>: <>
                <span>{canUseCouponCount} {intl.formatMessage({id: 'coupons',defaultMessage:'Coupons'})}</span>
            </>
        }
    </span>

    return <Tool onClick={onClick} value={couponName}>

        <span className={classes.CouponTitle}>
            <Iconfont className={classes.Icon}>&#xe6d9;</Iconfont>
            <FormattedMessage id="coupon" defaultMessage="Coupon" />
        </span>

    </Tool>
}